<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:m-0 m-4 login-inner">
      <vx-card>
        <div slot="no-body" class="">

          <div class="vx-row no-gutter justify-center items-center">

            <div class="vx-col sm:w-full md:w-full lg:w-full d-theme-dark-bg">
              <div class="auth-container">

                <div class="vx-card__title" v-if="imgPath != ''">

                  <div class="logo-wrap">
                    <div class="mx-auto logo-vendor" v-if="imgPath != ''">
                      <img :src="imgPath"　v-on:load="imgLoad">
                    </div>
                    <feather-icon icon="XIcon" class=""/>
                    <img class="mx-auto logo-amacode" src="@/assets/images/logo/main_logo.png" alt="Amacode">
                  </div>

                  <p class="mt-8 mb-2 text-center">
                    <span class="font-bold" v-if="service != ''">「{{service}}」</span>と<span class="font-bold">「Amacode Pro」</span><br>
                    の連携を許可しますか？
                  </p>

                  <div class="button-wrap">
                    <vs-button color="danger" type="filled" @click="cancelRequest()">キャンセル</vs-button>
                    <vs-button color="primary" type="filled" @click="requestPermission()">許可する</vs-button>
                  </div>


                </div>

                <div class="overlay" v-if="!isLoading && !infoFlag"><img src="@/assets/images/common/tail-spin.svg"></div>

                <p class="text-center" v-if="infoFlag">{{infomation}}</p>

              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
    <the-footer />
  </div>
</template>

<script>
import LoginFirebase from './LoginFirebase.vue'
import TheFooter from '@/layouts/components/TheFooter.vue'

import firebase from 'firebase/app'
import 'firebase/auth'
import store from '@/store/store'

export default{
  components: {
    LoginFirebase,
    TheFooter
  },
  data () {
    return{
      imgPath: '',      // firebaseへ保存しているサービスのロゴ画像パス
      service: '',      // firebaseへ保存しているサービス名
      serviceId: '',    // パラメータへ付与されているサービスid（client_id）
      serviceUri: '',    // パラメータへ付与されているリダイレクトURL（redirect_uri）
      isLoading: false, // 画像が読み込みされているかどうかのフラグ
      infoFlag: false,  // メッセージ表示
      infomation: ''    // メッセージ内容
    }
  },
  methods: {
    // ■ サービス画像の読み込みを検知する
    imgLoad() {
      this.isLoading = true
    },
    // ■ キャンセル時の処理
    cancelRequest(){
      const self = this
      this.infoFlag = true
      this.imgPath = ''
      this.infomation = '連携がキャンセルされました'

      setTimeout( function(){
        self.$router.push( { name: 'home'} )
      }, 2000 )
      
    },
    // ■ 連携リクエスト許可
    requestPermission(){
      this.$vs.loading()

      const self = this

      // ユーザーのトークンを取得して、トークンが取得できた場合リredirect_urlへパラメータを付けてリダイレクト
      const firebaseCurrentUser = firebase.auth().currentUser

      if (store.state.auth.isUserLoggedIn()) {
        const firebaseCurrentUser = firebase.auth().currentUser
        const dbUserServiceRef = firebase.database().ref('users/' + firebaseCurrentUser.uid + '/apps/' + this.service.toLowerCase() + '/' + this.serviceId )
        // データを作成して保存する
        const date = new Date()
        const timestamp = Math.floor( date.getTime() )
        let addData = {
          'createdat': timestamp
        }
        // DBへ追加
        dbUserServiceRef.update(addData)

        // リダイレクト
        firebase.auth().currentUser.getIdToken(true).then(function(idToken) {
          let url = self.serviceUri + '?token=' + idToken
          const urlCheck = self.serviceUri.match(/(https|http):\/\/.+/)

          if (!urlCheck) {
            url = 'https://' + url
          }

          window.location.href = url
        }).catch(function(error) {
          // Handle error
          console.log(error)
        })
      }
    }
  },
  
  // 判別した状態でした状態でログアウトさせて、URLパラメータにくっつける、
  // Amacode Proの申込みがされていないアカウントです。申込後、再度ログインをしてください。
  created: function(){
    // ログイン状態かの確認
    const firebaseCurrentUser = firebase.auth().currentUser
    // ログインしていたら
    if (store.state.auth.isUserLoggedIn()) {
      // client_idをベースにfirebaseからデーを取得
      // imgパスとサービス名を取得して、対象の変数へ挿入
      this.serviceId = this.$route.query.client_id
      this.serviceUri = this.$route.query.redirect_uri

      if (typeof this.serviceId != 'undefined' && this.serviceId != '' && this.serviceId != null) {
        const firebaseCurrentUser = firebase.auth().currentUser
        const self = this
        const dbProfileRef = firebase.database().ref('client_id/' + this.serviceId)
        dbProfileRef.on('value', (data) => {
          if (data.val() != null) {
            // name
            if (typeof data.val().name != 'undefined' && data.val().name != '' && data.val().name != null) {
              self.service = data.val().name
            }
            // thumb
            if (typeof data.val().thumb != 'undefined' && data.val().thumb != '' && data.val().thumb != null) {
              self.imgPath = data.val().thumb
            }
          } else {
            self.infoFlag = true
            self.infomation = 'エラーが発生しました。もう一度、サービス元から連携をお願いいたします。'
          }
        })
      }
    } else {
      /*
      // ログインしてなかったら
      // 対象のパラメータをチェックしてパラメータを付与し、ログインページへリダイレクト
      const client_id = this.$route.query.client_id
      const redirect_uri = this.$route.query.redirect_uri

      let option = {}

      if (typeof client_id != 'undefined' && client_id != '' && client_id != null) {
        option.client_id = client_id
      }

      if (typeof redirect_uri != 'undefined' && redirect_uri != '' && redirect_uri != null) {
        option.redirect_uri = redirect_uri
      }
      this.$router.push( { name: 'page-login', query: option } )
      */
    }
  }
}
</script>

<style lang="scss">
  #page-login {
    .login-inner{
      position: relative;
      z-index: 1;
    }
    .social-login-buttons {
      .bg-facebook { background-color: #1551b1 }
      .bg-twitter { background-color: #00aaff }
      .bg-google { background-color: #4285F4 }
      .bg-github { background-color: #333 }
    }
    .the-footer{
      position: absolute;
      bottom: 0;
      left: 0;
    }
  }
  .login-tabs-container {
    //min-height: 505px;

    .con-tab {
      padding-bottom: 14px;
    }

    .con-slot-tabs {
      margin-top: 1rem;
    }
  }
  .logo-amacode{
    width:150px;
    height: auto;
  }
  .logo-vendor{
    width: 150px;
    max-height: 31px;
    //margin: 25px auto 15px;
    //padding:10px 15px;
    img{
      width: 100%;
      height: auto;
    }
  }
  .btn-regist{
    cursor:pointer;
    a{
      transition: all .25s ease;
    }
    &:before{
      content:"";
      display:block;
      position: absolute;
      top:50%;
      right:15px;
      transform: translate(0,-50%) rotate(45deg);
      width:8px;
      height: 8px;
      border-right: 2px solid rgb(115, 103, 240);
      border-top: 2px solid rgb(115, 103, 240);
      transition: all .25s ease;
    }
    &:hover{
      color:#fff;
      background-color:rgb(115, 103, 240);
      &:before{
        border-color:#fff;
      }
      a{
        color:#fff;
      }
    }
  }
  .btn-danger{
    cursor:pointer;
    a{
      transition: all .25s ease;
    }
    &:before{
      content:"";
      display:block;
      position: absolute;
      top:50%;
      right:15px;
      transform: translate(0,-50%) rotate(45deg);
      width:8px;
      height: 8px;
      border-right: 2px solid rgb(115, 103, 240);
      border-top: 2px solid rgb(115, 103, 240);
      transition: all .25s ease;
    }
    &:hover{
      color:#fff;
      background-color:rgb(115, 103, 240);
      &:before{
        border-color:#fff;
      }
      a{
        color:#fff;
      }
    }
  }

  .auth-container{
    position: relative;
    padding: 40px 30px;
    border-radius: 10px;
  }
  .logo-wrap{
    display:flex;
    justify-content: center;
    flex-wrap:wrap;
    align-items:center;
    align-contents:center;
    >*{
      margin: 0 5px;
    }
  }
  .button-wrap{
    display:flex;
    justify-content: center;
    flex-wrap:wrap;
    align-items:center;
    align-contents:center;
    .vs-button{
      min-width:130px;
      margin: 10px 10px 0;
    }
  }

  .overlay{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #fff;
    img{
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
    }
  }
</style>
